import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useConnection } from '@gov-nx/core/hooks/Connection/setUseConnection';
import type { ResponseError } from '../errors/errors.types';
import { usePoResponseError } from '../errors/usePoResponseError';
import type { PoQueryConfig } from './types';

export const usePoMutation = <
	TData = unknown,
	TVariables = void,
	TContext = unknown,
>(
	options: UseMutationOptions<
		TData,
		AxiosError<ResponseError>,
		TVariables,
		TContext
	>,
	config?: PoQueryConfig
) => {
	const { handleError } = usePoResponseError();
	const { isOffline } = useConnection();

	return useMutation({
		...options,
		onError: (error, variables, context) => {
			// Note: Don't throw errors when no internet connection
			if (isOffline) return;

			if (config?.errorIgnoreFilter && config.errorIgnoreFilter(error)) {
				return;
			}
			handleError(error);

			options.onError?.(error, variables, context);
		},
	});
};
